export default {
  cn: {
    relation: {
      title: '关系图',
      list: {
        node_id: '账号',
        node_code: '代码',
        acc_type: '类型',
        acc_name: '姓名',
        enable: '状态'
      },
      type: {
        TD: '交易帐号',
        IB: '代理',
        SL: '职员',
        CL: '客户',
        M: '经理',
        O: '办事处',
        UN: '系统',
        C: '公司',
        N: '国家',
        R: '地区',
        one: '启用',
        two: '停用',
        F: '全职',
        P: '兼职',
        D: '离职'
      },
      seek: '搜索',
      nodata: "没有查询到数据"
    }
  },
  hk: {
    relation: {
      title: '關系圖',
      list: {
        node_id: '帳號',
        node_code: '代碼',
        acc_type: '類型',
        acc_name: '姓名',
        enable: '狀態'
      },
      type: {
        TD: '交易帳號',
        IB: '代理',
        SL: '職員',
        CL: '客戶',
        M: '經理',
        O: '辦事處',
        UN: '系統',
        C: '公司',
        N: '國家',
        R: '地區',
        one: '启用',
        two: '停用',
        F: '全職',
        P: '兼職',
        D: '離職'
      },
      seek: '搜索',
      nodata: "沒有查詢到數據"
    },
  },
  en: {
    relation: {
      title: 'Hierarchy',
      list: {
        node_id: 'Account ID',
        node_code: 'Code',
        acc_type: 'Account Type',
        acc_name: 'name',
        enable: 'enable'
      },
      type: {
        TD: 'TD',
        IB: 'IB',
        SL: 'Sales',
        CL: 'Client',
        M: 'manager',
        O: 'Office',
        UN: 'system',
        C: 'company',
        N: 'Country',
        R: 'region',
        one: 'enable',
        two: 'disable',
        F: 'full-time',
        P: 'part-time',
        D: 'dimission'
      },
      seek: 'search',
      nodata: "No data was found"
    },
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/relation.js